import PulteHomesLogo from "../assets/Logo-PulteHomes-4C-trans.png";
import DelWebbLogo from "../assets/Logo-DelWebb-4C-trans.png";
import DiVostaLogo from "../assets/Logo-DiVosta-4C-trans.png";
import CentexLogo from "../assets/Logo-Centex-4C-trans.png";
import JohnWielandLogo from "../assets/Logo-John-Weiland-4C-trans.png";
import AmericanWestLogo from "../assets/Logo-AmericanWest-4C-trans.png";
import PGPTitleLogo from "../assets/Logo-PGPTitle-4C-trans.png";
import PulteInsuranceLogo from "../assets/Logo-PIA-4C-trans.png";

const ALWAYS = (isAuthenticated) => {
    return true;
};
const NOT_LOGGED_IN = (isAuthenticated) => {
    return !isAuthenticated;
};
const LOGGED_IN = (isAuthenticated) => {
    return isAuthenticated;
};

const NOT_ON_HOMEPAGE = (isAuthenticated) => {
    return window.location.pathname !== "/";
};

const state = {
    returnUrl: null,
    webUser: {
        isLockedout: false,
        lockOutEnd: null
    },
    flags: [],
    defaultReturnUrl: "https://secure.pultemortgage.com/Dashboard/Home",
    siteLinks: {
        site: [
            {
                url: "/",
                title: "Home",
                css: "",
                nav: false,
                foot: true,
                displayCondition: NOT_ON_HOMEPAGE,
                target: "_self"
            },
            {
                url: "/about",
                title: "About",
                css: "",
                nav: true,
                foot: false,
                displayCondition: ALWAYS,
            },
            {
                url: "/about",
                title: "About",
                css: "",
                nav: false,
                foot: true,
                displayCondition: ALWAYS,
            },
            {
                url: "/our-process",
                title: "Our Process",
                css: "",
                nav: true,
                foot: true,
                displayCondition: ALWAYS,
            },
            {
                url: "/leadership",
                title: "Leadership",
                css: "",
                nav: true,
                foot: true,
                displayCondition: ALWAYS,
            },
            {
                url: "/afterclosing",
                title: "After Closing",
                css: "",
                nav: true,
                foot: true,
                displayCondition: ALWAYS,
                target: "_self"
            },
            {
                url:
                    "/top-mortgage-questions",
                title: "What to Expect",
                css: "pad",
                nav: false,
                foot: true,
                displayCondition: ALWAYS,
                ariaLabel: "After Closing: What to Expect"
            },
            {
                url: "https://servicing.pultemortgage.com/pultemortgage/#/login",
                title: "Make a Payment",
                css: "pad",
                nav: false,
                foot: true,
                displayCondition: ALWAYS,
                target: "_blank",
                key: "paymentLink",
                ariaLabel: "After Closing: Make a Payment (Link opens in a new tab)"
            },
            {
                url: "/resources",
                title: "Resources",
                css: "",
                nav: true,
                foot: true,
                displayCondition: ALWAYS,
            },
            // If the blog returns, we may need to add the new blog URL here.
            // {
            //     url: "https://blog.pultemortgage.com/",
            //     title: "Blog",
            //     css: "",
            //     nav: true,
            //     foot: true,
            //     displayCondition: ALWAYS,
            //     target: "_blank",
            //     ariaLabel: "Blog (Link opens in a new tab)"
            // },
            {
                url: "/contact",
                title: "Contact",
                css: "",
                nav: true,
                foot: true,
                displayCondition: ALWAYS,
            },
            {
                url: "/login",
                title: "Login",
                css: "",
                nav: false,
                foot: true,
                displayCondition: NOT_LOGGED_IN,
            },
            {
                url: "/registernow",
                title: "Register Now",
                css: "",
                nav: false,
                foot: true,
                displayCondition: NOT_LOGGED_IN,
            },
            {
                url: "/loginhelp",
                title: "LoginHelp",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_self"
            },
            {
                url: "//secure.pultemortgage.com/Dashboard/Home",
                title: "Dashboard",
                css: "",
                nav: true,
                foot: true,
                displayCondition: LOGGED_IN,
                target: "_self"
            },
            {
                url: "/disaster-information",
                title: "DisasterInformation",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_self"
            },
            {
                url: "/homeowner-counseling",
                title: "HomeownerCounselingResources",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_self"
            },
            {
                url:
                    "/mortgage-payment-help",
                title: "SpecialAssistancePrograms",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_self"
            },
            {
                url: "/glossary",
                title: "TerminologyAfterClosing",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_self"
            },
            {
                url: "/servicefees",
                title: "Servicing Fee Schedule",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_self"
            },
            {
                url: "/learn-more-about-making-payments",
                title: "Make Your Mortgage Payment",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_self"
            },
            {
                url: "https://www.pultemortgage.com/hai/",
                title: "Buying Power Calculator",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_blank"
            },
            {
                url: "/buying-power-calculator-faq",
                title: "Buy Power Calculator FAQ",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_blank"
            },
            {
                url:
                    "https://login.pultemortgage.com/mortgage-types",
                title: "Which Mortgage is right for me?",
                css: "",
                nav: false,
                foot: false,
                displayCondition: ALWAYS,
                target: "_blank"
            },
            { url: "https://start.pultemortgage.com", key: "startUrl" }
        ],
        familyOfBrands: [
            {
                title: "Pulte Homes",
                url: "https://www.pulte.com/",
                target: "_blank",
                css: "",
                img: PulteHomesLogo,
                showInFooter: true,
                alt: 'Pulte Homes Logo',
                ariaLabel: "Pulte Homes — opens in a new tab"
            },
            {
                title: "Del Webb",
                url: "https://www.delwebb.com/",
                target: "_blank",
                css: "",
                img: DelWebbLogo,
                showInFooter: true,
                alt: "Del Webb Logo",
                ariaLabel: "Del Webb — opens in a new tab"
            },
            {
                title: "DiVosta",
                url: "https://www.divosta.com/",
                target: "_blank",
                css: "",
                img: DiVostaLogo,
                showInFooter: true,
                alt: "DiVosta Logo",
                ariaLabel: "DiVosta — opens in a new tab"
            },
            {
                title: "Centex",
                url: "https://www.centex.com/",
                target: "_blank",
                css: "",
                img: CentexLogo,
                showInFooter: true,
                alt: "Centex Logo",
                ariaLabel: "Centex — opens in a new tab"
            },
            {
                title: "John Wieland",
                url: "https://www.jwhomes.com/",
                target: "_blank",
                css: "",
                img: JohnWielandLogo,
                showInFooter: true,
                alt: "John Wieland Homes Logo",
                ariaLabel: "John Wieland Homes — opens in a new tab"
            },
            {
                title: "American West Homes",
                url: "https://www.americanwesthomes.com/",
                target: "_blank",
                css: "",
                img: AmericanWestLogo,
                showInFooter: true,
                alt: "American West Homes Logo",
                ariaLabel: "American West Homes — opens in a new tab"
            },
            {
                title: "PGP Title",
                url: "http://www.pgptitle.com/",
                target: "_blank",
                css: "",
                img: PGPTitleLogo,
                showInFooter: true,
                alt: "PGP Title Logo",
                ariaLabel: "PGP Title — opens in a new tab"
            },
            {
                title: "Pulte Insurance Agency",
                url: "http://www.pulteinsuranceagency.com/",
                target: "_blank",
                css: "",
                img: PulteInsuranceLogo,
                showInFooter: true,
                alt: "Pulte Insurance Logo",
                ariaLabel: "Pulte Insurance Agency — opens in a new tab"
            }
        ],
        copyright: [
            { url: "/contact", title: "Licensing Information", css: "" },
            { url: "/privacy-policy", title: "Privacy Policy", css: "" },
            { url: "/security", title: "Security Information", css: "" },
            { url: "/servicefees", title: "Servicing Fee Schedule", css: "" },
            { url: "/faq", title: "Site Info & FAQs", css: "" },
            { url: "/termsofuse", title: "Terms of Use", css: "" },
            { url: "/do-not-sell-or-share-my-personal-information", title: "Do Not Sell or Share My Personal Information", css: "" }
        ],
        careers: [
            { title: 'External Candidates', url: 'https://www.themuse.com/profiles/pultemortgage', target: '_blank', css: '', showInFooter: true, ariaLabel: "External Candidates (Link opens in a new tab)", },
            { title: 'Current Employees', url: 'https://www.myworkday.com/wday/authgwy/pultegroup/login.htmld?returnTo=%2fpultegroup%2fd%2ftask%2f3005%244482.htmld', target: '_blank', css: '', showInFooter: true, ariaLabel: "Current Employees (Link opens in a new tab)", }
        ]
    },
    support: {
        email: "mortgagewebsupport@pulte.com",
        phone: "1 (866) 236-8165",
        daysOfWeek: "Monday-Friday",
        hours: "7:00am-6:00pm MST"
    },
    testimonials: {
        numberPerPage: 3,
        reviews: [
            {
                comment:
                    "“We could not be any happier.  Thank you, Pulte Team, for making this happen for us! To be able to take the keys to our new home last week was a dream.  Five stars across the board, we will be customers for life!”",
                name: "Timothy T.",
                state: "Washington"
            },
            {
                comment:
                    "“As an executive in this industry, I definitely have high expectations when dealing with financial institutions.  Everyone on the Pulte team was professional and exceeded those expectations. It really was a painless process and I have high-regard for all the team members I worked with.”",
                name: "Renae I.",
                state: "Texas"
            },
            {
                comment:
                    "“I felt very supported throughout the whole process. Everyone went to great lengths to help me understand the process and ensure I had everything filled out correctly. The whole process was quite smooth!”",
                name: "Elsa S.",
                state: "South Carolina"
            },
            {
                comment:
                    "“Everyone I worked with at Pulte Mortgage was courteous and professional.  My Loan Consultant and Processor were outstanding and kept me in-the-loop throughout the entire process. They really kept the process as easy as possible.”",
                name: "Ken K.",
                state: "Georgia"
            },
            {
                comment:
                    "“The mortgage process was smooth, and I felt at ease during the entire process.  If I had to do it all over again, I would still choose to work with my same Pulte Mortgage team. Thank you for making this new life experience easy!”",
                name: "Raymond O.",
                state: "Texas"
            },
            {
                comment:
                    "“From the beginning to end, Pulte Mortgage made this such an easy process.  Our Loan Team was very knowledgeable and helpful working with us to get our loan closed in a quick time frame. Thanks again to all we worked with!”",
                name: "Lisa S.",
                state: "Arizona"
            }
        ]
    },
    showFooter: true
};

export { state };
